import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PropertiesPage from './pages/PropertiesPage';
import ClientViewCreatePage from './pages/ClientViewCreatePage';
import ClientViewDetailPage from './pages/ClientViewDetailPage';
import PublicClientViewPage from './pages/PublicClientViewPage';
import InvitePage from './pages/InvitePage';
import ClientLoginPage from './pages/ClientLoginPage';
import ClientPortalPage from './pages/ClientPortalPage';
import AgentDashboardPage from './pages/AgentDashboardPage';
import ClientDetailPage from './pages/ClientDetailPage';
import LeadsPage from './pages/LeadsPage';
import BuscarPage from './pages/BuscarPage';
import PropertyFormPage from './pages/PropertyFormPage';
import PropertiesAdminPage from './pages/PropertiesAdminPage';
import AgencySettingsPage from './pages/AgencySettingsPage';
import ClientViewsPage from './pages/ClientViewsPage';
import RentalsDashboardPage from './pages/RentalsDashboardPage';
import LeasesPage from './pages/LeasesPage';
import LeaseDetailPage from './pages/LeaseDetailPage';
import LeaseCreatePage from './pages/LeaseCreatePage';
import RentalTenantsPage from './pages/RentalTenantsPage';
import LandingPage from './pages/LandingPage';
import VerifyEmailPage from './pages/VerifyEmailPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          {/* Pública: el link del correo verifica sin sesión (auth 007) */}
          <Route path="/verificar" element={<VerifyEmailPage />} />
          <Route path="/properties" element={<ProtectedRoute><PropertiesPage /></ProtectedRoute>} />
          <Route path="/client-views/new" element={<ProtectedRoute><ClientViewCreatePage /></ProtectedRoute>} />
          <Route path="/client-views/:id" element={<ProtectedRoute><ClientViewDetailPage /></ProtectedRoute>} />
          <Route path="/public/views/:token" element={<PublicClientViewPage />} />
          <Route path="/agencies/:agencyId/invite" element={<ProtectedRoute><InvitePage /></ProtectedRoute>} />
          <Route path="/portal/login" element={<ClientLoginPage />} />
          <Route path="/portal" element={<ClientPortalPage />} />
          <Route path="/agent/clients" element={<ProtectedRoute><AgentDashboardPage /></ProtectedRoute>} />
          <Route path="/agent/clients/:clientId" element={<ProtectedRoute><ClientDetailPage /></ProtectedRoute>} />
          <Route path="/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
          <Route path="/buscar" element={<BuscarPage />} />
          <Route path="/admin/properties" element={<ProtectedRoute><PropertiesAdminPage /></ProtectedRoute>} />
          <Route path="/admin/properties/new" element={<ProtectedRoute><PropertyFormPage /></ProtectedRoute>} />
          <Route path="/admin/properties/:id/edit" element={<ProtectedRoute><PropertyFormPage /></ProtectedRoute>} />
          <Route path="/admin/agency" element={<ProtectedRoute><AgencySettingsPage /></ProtectedRoute>} />
          <Route path="/agent/client-views" element={<ProtectedRoute><ClientViewsPage /></ProtectedRoute>} />
          <Route path="/admin/rentals" element={<ProtectedRoute><RentalsDashboardPage /></ProtectedRoute>} />
          <Route path="/admin/rentals/leases" element={<ProtectedRoute><LeasesPage /></ProtectedRoute>} />
          <Route path="/admin/rentals/leases/new" element={<ProtectedRoute><LeaseCreatePage /></ProtectedRoute>} />
          <Route path="/admin/rentals/leases/:id" element={<ProtectedRoute><LeaseDetailPage /></ProtectedRoute>} />
          <Route path="/admin/rentals/tenants" element={<ProtectedRoute><RentalTenantsPage /></ProtectedRoute>} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/rentas" element={<LandingPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
